import script from "./DashboardSummaryGrid.vue?vue&type=script&lang=ts&setup=true"
export * from "./DashboardSummaryGrid.vue?vue&type=script&lang=ts&setup=true"

import "./DashboardSummaryGrid.vue?vue&type=style&index=0&id=1c21fd22&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c21fd22"]])

export default __exports__